
import { Component, Vue, Prop } from "vue-property-decorator";

import moment from "moment";
moment.locale("es");

@Component({
  computed: {},
  watch: {
    commentsProp(newVal, oldVal) {
      (this as any).comments = newVal.map(comment => ({
        name:
          (comment.admin && comment.admin.fullname) ||
          (comment.subscriptor && comment.subscriptor.fullname),
        content: comment.content,
        date: moment(comment.createdAt).format("LL"),
        pic: null
      }));
    }
  }
})
export default class Dashboard extends Vue {
  @Prop(Array) readonly commentsProp: any;
  @Prop(Function) readonly seeMoreComments;
  comments: any = [];
  async mounted() {}
}
